<mat-card class="estimate-card">
    <mat-card-content>
        <!-- Fieldset to disable/blur the content based on the disablePage condition -->
        <fieldset [disabled]="disablePage$ | async"
            [ngClass]="{'blur': disablePage$ | async, 'no-blur': !(disablePage$ | async)}">
            <div class="container-fluid">
                <div class="row">
                    <ng-container *ngIf="(projectHeadline$ | async)">
                        <div class="col-lg">
                            <h4><strong>{{ projectHeadline$ | async }}</strong></h4>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!(projectHeadline$ | async)">
                        <div class="col-lg">
                            <h4><strong>EstiMate is listening...</strong></h4>
                        </div>
                    </ng-container>
                    <div class="d-flex justify-content-end mb-1">
                        <div class="toolbar py-1 px-3 float-right">
                            <!-- <img src="./assets/img/play_icon.svg" title="Play" class="cursor-pointer" /> -->
                            <ng-container *ngIf="(selectedIndex$ | async) !== 2">
                                <button class="white-button mb-2 mt-2" [disabled]="(selectedIndex$ | async) !== 2"
                                    [matTooltip]="'Copy project plan on step 3'" (click)="copyAsText($event)">
                                    <img src="./assets/img/copy_icon.svg" />
                                    <!-- content_copy -->
                                </button>
                            </ng-container>
                            <ng-container *ngIf="(selectedIndex$ | async) === 2">
                                <button class="white-button mb-2 mt-2" [disabled]="(selectedIndex$ | async) !== 2"
                                    [matTooltip]="isCopied ? 'Copied Successfully!' : 'Copy as Text'"
                                    (click)="copyAsText($event)">
                                    <img src="./assets/img/copy_icon.svg" />
                                    <!-- content_copy -->
                                </button>
                            </ng-container>
                            <div class="menu-btn ml-3 d-inline-block" [matMenuTriggerFor]="menu">
                                <img src="./assets/img/open_slides_blue_icon.svg" title="Download as" />
                                <span type='button' class="text-primary mx-2">Export</span>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item [disabled]="true" [matTooltip]="'Available soon'"><img
                                            src="./assets/img/open_slides_icon.svg" title="Open in Slides"
                                            class="mr-2" />Open in Slides</button>
                                    <button mat-menu-item [disabled]="true" [matTooltip]="'Available soon'"><img
                                            src="./assets/img/pdf_icon.svg" title="Download as PDF"
                                            class="mr-2" />Download as PDF</button>
                                </mat-menu>
                                <img src="./assets/img/down_arrow.svg" title="Download as" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <mat-tab-group animationDuration="{{ animationTime }}">
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    <div *ngIf="!((store$ | async).stepOne.display)" class='circle'>1</div>
                                    <div *ngIf="((store$ | async).stepOne.display)" class="material-icons circle">check
                                    </div>
                                    <div>Project Classification</div>
                                </ng-template>
                                <div>
                                    <ng-template matTabContent>
                                        <app-estimate-classification></app-estimate-classification>
                                    </ng-template>
                                </div>
                            </mat-tab>
                            <mat-tab [disabled]="!((store$ | async).stepOne.display)">
                                <ng-template mat-tab-label>
                                    <div *ngIf="!((store$ | async).stepTwo.display)" class='circle'>2</div>
                                    <div *ngIf="((store$ | async).stepTwo.display)" class="material-icons circle">check
                                    </div>
                                    <div>Project Length</div>
                                </ng-template>
                                <div>
                                    <ng-template matTabContent>
                                        <app-estimate-timeframe></app-estimate-timeframe>
                                    </ng-template>
                                </div>
                            </mat-tab>
                            <mat-tab [disabled]="!((store$ | async).stepTwo.display) || this.error">
                                <ng-template mat-tab-label>
                                    <div *ngIf="!((store$ | async).stepThree.display)" class='circle'>3</div>
                                    <div *ngIf="((store$ | async).stepThree.display)" class="material-icons circle">
                                        check
                                    </div>
                                    <div>Project Plan</div>
                                </ng-template>
                                <ng-container *ngIf="allowTable">
                                    <app-estimate-table></app-estimate-table>
                                </ng-container>
                            </mat-tab>
                            <mat-tab [disabled]="!((store$ | async).stepThree.display) || this.error">
                                <ng-template mat-tab-label>
                                    <div *ngIf="!((store$ | async).stepThree.display)" class='circle'>4</div>
                                    <div *ngIf="((store$ | async).stepThree.display)" class="material-icons circle">
                                        check
                                    </div>
                                    <div>Chart View</div>
                                </ng-template>
                                <ng-template matTabContent>
                                    <app-estimate-chart></app-estimate-chart>
                                </ng-template>
                            </mat-tab>
                        </mat-tab-group>
                    </div>
                </div>
            </div>
        </fieldset>
        <div *ngIf="disablePage$ | async">
            <app-estimate-loading></app-estimate-loading>
        </div>
    </mat-card-content>
</mat-card>